import { render, staticRenderFns } from "./RuleArticle.vue?vue&type=template&id=bf51950a&scoped=true"
import script from "./RuleArticle.vue?vue&type=script&lang=js"
export * from "./RuleArticle.vue?vue&type=script&lang=js"
import style0 from "./RuleArticle.vue?vue&type=style&index=0&id=bf51950a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf51950a",
  null
  
)

export default component.exports